<template>
    <el-dialog title="出库" :visible.sync="dialogVisible" width="42%" :close-on-click-modal="false" top="8vh" @close="close">
<!--        <upload-excel-component :on-success="handleSuccess" />-->
        <el-form label-width="100px">
            <el-form-item label="重量">
                <el-input size="mini" v-model="formData.channelWeight"></el-input>
            </el-form-item>
            <el-form-item label="长">
              <el-input size="mini" v-model="formData.length"></el-input>
            </el-form-item>
            <el-form-item label="宽">
              <el-input size="mini" v-model="formData.width"></el-input>
            </el-form-item>
            <el-form-item label="高">
              <el-input size="mini" v-model="formData.height"></el-input>
            </el-form-item>
            <el-form-item label="国际运单号">
                <el-input
                    size="mini"
                    v-model="formData.conveyNumber"
                    autofocus
                    @keyup.enter.native="handleConveyNumberEnter">
                </el-input>
            </el-form-item>

            <!-- Ozon 超重警告提示 -->
            <el-alert
                v-if="ozonWarning.show"
                :title="ozonWarning.message"
                type="warning"
                :closable="true"
                @close="ozonWarning.show = false"
                :class="{'flash-warning': ozonWarning.flash}"
                style="margin-top: 10px; max-height: 100px; overflow-y: auto;">
                <div slot="default">
                    <p style="margin: 5px 0;"><strong>订单号:</strong> {{ ozonWarning.data['订单号'] }}</p>
                    <p style="margin: 5px 0;"><strong>运单号:</strong> {{ ozonWarning.data['运单号'] }}</p>
                    <p style="margin: 5px 0;"><strong>实际称重:</strong> {{ formData.channelWeight }}g</p>
                    <p style="margin: 5px 0;"><strong>标准范围:</strong> {{ ozonWarning.standardRange }}g</p>
                    <p style="margin: 5px 0;"><strong>允许最大:</strong> {{ ozonWarning.maxAllowedWeight }}g (含5%容差)</p>
                    <p style="margin: 5px 0; color: #f56c6c; font-weight: bold;"><strong>⚠️ 超出: {{ ozonWarning.overweightAmount }}g</strong></p>
                    <p style="margin: 5px 0;"><strong>配送渠道:</strong> {{ ozonWarning.data['配送渠道'] }}</p>
                    <p style="margin: 5px 0;"><strong>所属店铺:</strong> {{ ozonWarning.data['所属店铺'] }}</p>
                </div>
            </el-alert>
        </el-form>
<!--        <el-table :data="tableData" border style="margin-top: 20px;">-->
<!--            <el-table-column label="国际运单号" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <div :style="{color: isRepeat(scope.row) ? 'red' : ''}">{{ scope.row.conveyNumber }}</div>-->
<!--                    &lt;!&ndash; <el-input-->
<!--                        v-model="scope.row.conveyNumber"-->
<!--                        placeholder="请输入内容"-->
<!--                    ></el-input> &ndash;&gt;-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            &lt;!&ndash; @blur="outConveyNumber(scope.row)" &ndash;&gt;-->
<!--            &lt;!&ndash; <el-table-column label="尺寸" align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input-->
<!--                        v-model="scope.row.channelSize"-->
<!--                        placeholder="请输入内容"-->
<!--                        :readonly="!scope.row.isEdit"-->
<!--                    ></el-input>-->
<!--                </template>-->
<!--            </el-table-column> &ndash;&gt;-->
<!--            <el-table-column label="长" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.length"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="宽" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.width"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="高" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.height"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="重量" align="center" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-input v-model="scope.row.channelWeight"></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="操作" width="140" align="center">-->
<!--                &lt;!&ndash; <template slot="header">-->
<!--                    <el-button type="primary" size="small" @click="addTable">添加</el-button>-->
<!--                </template> &ndash;&gt;-->
<!--                <template slot-scope="scope">-->
<!--                    &lt;!&ndash; <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        v-if="!scope.row.isEdit"-->
<!--                        @click="scope.row.isEdit = true"-->
<!--                    >编辑</el-button>-->
<!--                    <el-button-->
<!--                        type="success"-->
<!--                        size="small"-->
<!--                        v-else-if="scope.row.isEdit"-->
<!--                        @click="scope.row.isEdit = false"-->
<!--                    >确定</el-button> &ndash;&gt;-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        size="small"-->
<!--                        @click="del(scope)"-->
<!--                    >删除</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--        </el-table>-->
        <span slot="footer" class="dialog-footer">
            <el-row type="flex" justify="space-between" align="middle">
<!--                <div>共 {{ tableData.length }} 条</div>-->
              <div></div>
                <el-button type="primary" @click="OutofstockDetermine" :loading="loadingStatus" :disabled="isDisabled">确 定</el-button>
            </el-row>
            <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import axios from 'axios'
// import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
    name: "Outofstock",
    components: {
        // UploadExcelComponent
    },
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            formData: {
                conveyNumber: '',
                channelWeight: '',
                length: '1',
                width: '1',
                height: '1',
            },
          loadingStatus: false,
          // Ozon 超重警告
          ozonWarning: {
            show: false,
            flash: false,
            message: '',
            data: {},
            overweightAmount: 0,
            maxAllowedWeight: 0,  // 允许的最大重量（标准范围上限 * 1.05）
            standardRange: ''      // 标准范围字符串
          }
        };
    },
    computed: {
        isDisabled() {
            const tempConveyNumber = this.tableData.map(item => item.conveyNumber)
            const repeatArr = new Set([...tempConveyNumber])
            if (repeatArr.size === tempConveyNumber.length) return false
            return true
        }
    },
    methods: {
        isRepeat(item) {
          const { conveyNumber } = item
          const resultArr = this.tableData.filter(key => key.conveyNumber === conveyNumber)
          return resultArr.length > 1 ? true : false
        },
        openWebSocket() {
          if (window.WebSocket) {
            this.ws = new WebSocket('ws://localhost:4397/');

            this.ws.onopen = (e) => {
              console.log("连接服务器成功");
              this.ws.send("start");
            }
            this.ws.onclose = (e) => {
              console.log("服务器关闭");
            }
            this.ws.onerror = () => {
              console.log("连接出错");
            }
            this.ws.onmessage = (e) => {
              // console.log(e.data);
              const dataStr = e.data
              this.formData.channelWeight = dataStr

              // 称重后检查是否超重
              this.checkOverweightAfterWeigh()
            }
          }
        },
        hanldeKeyup(e) {
            // if (!this.formData.channelWeight || !this.formData.conveyNumber || !this.dialogVisible) return
            if (e.keyCode === 13) {
                // this.addTable()
              this.OutofstockDetermine()
            }
        },
        // 处理运单号输入框回车事件（扫码后的回车）
        async handleConveyNumberEnter(e) {
          const conveyNumber = this.formData.conveyNumber.trim()
          if (!conveyNumber) {
            return
          }

          // 检测 Ozon 订单信息（获取标准重量范围）
          await this.checkOzonInfo(conveyNumber)
        },
        init() {
            this.dialogVisible = true;
            // this.tableData = [
            //     {
            //         id: 1,
            //         conveyNumber: "",
            //         channelSize: "",
            //         channelWeight: "",
            //         channelName: "",
            //         isEdit: false
            //     }
            // ];
            this.tableData = [];
            this.openWebSocket()
          window.addEventListener('keyup', this.hanldeKeyup)
        },
        close() {
          this.dialogVisible = false;
          this.loadingStatus = false
            // this.$once('hook:beforeDestroy', () => {
          window.removeEventListener('keyup', this.hanldeKeyup)
            // })
        },
        closeLoading() {
          this.loadingStatus = false
          this.formData = {
            conveyNumber: '',
            channelWeight: '',
            length: '1',
            width: '1',
            height: '1',
          }
          // 清除 Ozon 警告
          this.ozonWarning = {
            show: false,
            flash: false,
            message: '',
            data: {},
            overweightAmount: 0,
            maxAllowedWeight: 0,
            standardRange: ''
          }
        },
        // 检测 Ozon 订单信息（获取标准重量范围）
        async checkOzonInfo(conveyNumber) {
          if (!conveyNumber) {
            return
          }

          try {
            // 调用 Ozon 检测接口，设置 3 秒超时
            const response = await axios.post('https://ozoncheck.hz.hyxun.top/api/check_track', {
              track_number: conveyNumber
            }, {
              headers: {
                'Content-Type': 'application/json'
              },
              timeout: 3000  // 3 秒超时
            })

            const data = response.data

            // 判断是否是 Ozon 订单
            if (data && data.is_ozon) {
              const standardRange = data['标准范围_g'] || '0 - 0'
              const maxWeight = parseFloat(standardRange.split(' - ')[1]) || 0
              const allowedMaxWeight = maxWeight * 1.05 // 允许超出 5%

              // 保存标准重量范围信息（稍后与实际称重对比）
              this.ozonWarning.data = data
              this.ozonWarning.maxAllowedWeight = allowedMaxWeight
              this.ozonWarning.standardRange = standardRange

              console.log(`✅ Ozon 订单: ${conveyNumber}, 标准范围: ${standardRange}g, 允许最大: ${allowedMaxWeight}g`)
            } else {
              // 非 Ozon 订单，清除信息
              this.ozonWarning.data = {}
              this.ozonWarning.maxAllowedWeight = 0
              this.ozonWarning.standardRange = ''
              console.log(`ℹ️ 非 Ozon 订单: ${conveyNumber}`)
            }
          } catch (error) {
            // 详细错误处理
            if (error.code === 'ECONNABORTED') {
              console.warn(`⏱️ Ozon API 超时: ${conveyNumber} (3秒)`)
            } else if (error.response) {
              // 服务器返回了错误状态码
              console.warn(`⚠️ Ozon API 错误 (${error.response.status}): ${conveyNumber}`)
            } else if (error.request) {
              // 请求已发出但没有收到响应
              console.warn(`📡 Ozon API 无响应: ${conveyNumber}`)
            } else {
              // 其他错误
              console.warn(`❌ Ozon API 请求失败: ${conveyNumber}`, error.message)
            }

            // 静默失败，不影响正常出库流程
            this.ozonWarning.data = {}
            this.ozonWarning.maxAllowedWeight = 0
            this.ozonWarning.standardRange = ''
          }
        },
        // 称重后检查是否超重
        checkOverweightAfterWeigh() {
          const currentWeight = parseFloat(this.formData.channelWeight) || 0
          const maxAllowedWeight = this.ozonWarning.maxAllowedWeight

          // 如果有 Ozon 订单信息且已称重，检查是否超重
          if (maxAllowedWeight > 0 && currentWeight > 0) {
            const overweightAmount = currentWeight - maxAllowedWeight

            if (overweightAmount > 0) {
              // 超重了！显示警告
              this.ozonWarning.overweightAmount = overweightAmount.toFixed(2)
              this.ozonWarning.message = `⚠️ Ozon 订单超重警告！超出 ${overweightAmount.toFixed(2)}g`
              this.ozonWarning.show = true

              // 触发闪烁动画
              this.triggerFlash()

              // 播放提示音（已禁用）
              // this.playWarningSound()
            } else {
              // 未超重，隐藏警告
              this.ozonWarning.show = false
            }
          }
        },
        // 触发闪烁动画
        triggerFlash() {
          this.ozonWarning.flash = true
          setTimeout(() => {
            this.ozonWarning.flash = false
          }, 1000) // 闪烁 1 秒
        },
        // 播放警告提示音
        playWarningSound() {
          try {
            const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzN2z+O1k1ALIHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzN2z+O1k1ALIHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzN2z+O1k1ALIHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzN2z+O1k1ALIHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzN2z+O1k1ALIA==')
            audio.volume = 0.3
            audio.play().catch(err => console.log('播放提示音失败:', err))
          } catch (error) {
            console.log('播放警告音失败:', error)
          }
        },
        addTable() {
            this.tableData.push({
                length: '1',
                width: '1',
                height: '1',

                ...this.formData
            });
            this.formData = {
                conveyNumber: '',
                channelWeight: ''
            }
        },
        del(scope) {
            this.$confirm("您确定要删除此信息吗？", "提示")
                .then(() => {
                    const itemIndex = scope.$index
                    this.tableData.splice(itemIndex, 1)
                })
                .catch(() => {
                    this.$message.info("取消操作");
                });
        },
      OutofstockDetermine() {
          // const data = [];
          // for (const item of this.tableData) {
          //   if (item.conveyNumber && item.length && item.width && item.height && item.channelWeight) {
          //     data.push(item);
          //   } else {
          //     this.$message.warning("请将信息填写完整");
          //     return;
          //   }
          // }
          // if (!data.length) {
          //   this.$message.error("请至少填写一项信息");
          //   return;
          // }
          if (!this.formData.channelWeight) {
            this.$message.warning('请输入重量')
            return
          }
          if (!this.formData.conveyNumber) {
            this.$message.warning('请输入国内运单号')
            return
          }
          this.loadingStatus = true
          this.$emit("confirm", [this.formData]);
        },
        outConveyNumber(row) {
            if (!row.conveyNumber || row.channelName) return;
            const API =
                Baseurl + "logisticsController/getOrderChannelByConveyNumber";
            const paramsData = {
                conveyNumber: row.conveyNumber
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    row.channelName = data.channelName;
                } else {
                    row.conveyNumber = "";
                    this.$message.error(data);
                }
            });
        },
        handleSuccess({ results, header }) {
            this.tableData = results.map((item, index) => {
                return {
                    id: index,
                    conveyNumber: item.运单号,
                    length: item.长,
                    width: item.宽,
                    height: item.高,
                    channelWeight: item.重量
                }
            })
            // this.tableHeader = header
            console.log(results, header)
        }
    }
};
</script>
<style scoped>
/* 黄色闪烁动画 */
.flash-warning {
  animation: flashYellow 1s ease-in-out;
}

@keyframes flashYellow {
  0%, 100% {
    background-color: #fff;
    box-shadow: 0 0 0 rgba(255, 193, 7, 0);
  }
  50% {
    background-color: #fff9c4;
    box-shadow: 0 0 20px rgba(255, 193, 7, 0.8);
  }
}

/* 警告提示框样式优化 */
.el-alert {
  border-radius: 4px;
}

.el-alert p {
  font-size: 13px;
  line-height: 1.5;
}
</style>

